window.AdvancedAnalyticsSetup = (function() {
	const AdvancedAnalyticsStylesCache = new Map();
	const AdvancedAnalyticsDataCache = new Map();

	let defaultAdvancedAnalyticsSettings;

	function getBitFlags(checkboxClass) {
		var val = 0;
		$(checkboxClass + "[type='checkbox']:enabled").each(function() {
			if ($(this).is(':checked')) val += parseInt($(this).val() || 0, 10);
		});
		return val;
	}

	function setBitFlags(checkboxClass, bitmask) {
		$(checkboxClass + "[type='checkbox']").each(function () {
			var val = parseInt($(this).val() || 0, 10);
			$(this).attr("checked", (val & bitmask) == val);
		});
	}

	return {
		settingsLoaded: false,
		filtersLoaded: false,
		currentLayoutElementItem: null,

		setStyleCacheWithGuid: function (styles, guid) {
			AdvancedAnalyticsStylesCache.set(guid, styles);
		},

		getStyleCacheWithGuid: function (guid) {
			return AdvancedAnalyticsStylesCache.get(guid);
		},

		setDataToCache: function (data, guid) {
			AdvancedAnalyticsDataCache.set(guid, data);
		},

		getDataFromCache: function(guid) {
			return AdvancedAnalyticsDataCache.get(guid);
		},

		loadTabs: function() {
			$('#advancedanalyticstabholder').tabs('destroy');
			$('#advancedanalyticstabholder').removeClass('ui-widget');
			$('#advancedanalyticstabholder').tabs({
				selected: 0,
				show: function (evt, ui) {
					if (ui.index === 1) {
						$('#aa_filterBox .filterboxHeaderWrapper td').equalHeights();
					}
				},
			});
		},

		setupUIElements: function() {
			$('#divAdvancedAnalytics').empty();

			$('#aa_layout').append($('#layout > fieldset').attr('data-collapse-group', '#aa_layout'));
			$('#aa_layout').find('.ColorTextbox').DUIColorPicker({ layout: 'template' });

			var alwaysHide = [
				'#divAdvancedAnalytics',
				'#divAdvancedAnalyticsTable',
				'.showDivTable',
				'.invertBackground',
				'#GaugeSettings',
			];

			$(alwaysHide.join(',')).hide();

			$('#chartstyle_series_marker_enabled').closest('tr').hide();
			$('#chartstyle_series_lineWidth').closest('.settingsFieldsetContent').hide();

			$('.aaDateVar').toggle($('#aa_ddlDateVar option').length > 1);

			$("#chbInvertAdvancedAnalyticsPreview").attr('checked', false).trigger("change");
			$("#chbShowAdvancedAnalyticsTable").attr('checked', false);
		},

		setupEditPanel: function (layoutElementItem) {
			AdvancedAnalyticsSetup.currentLayoutElementItem = layoutElementItem;

			AdvancedAnalyticsSetup.setupUIElements();

			Storyboard.Dependency.start('ADVANCEDANALYTICS', 'LoadAdvancedAnalytics');

			Promise.all([
				AdvancedAnalyticsSetup.loadFilters(),
				AdvancedAnalyticsSetup.getFilterTestSets(),
				AdvancedAnalyticsSetup.loadStyles(layoutElementItem),
				AdvancedAnalyticsSetup.loadSettings(layoutElementItem),
			]).then(function() {
				Storyboard.Dependency.complete('ADVANCEDANALYTICS', 'LoadAdvancedAnalytics');
			});
		},

		clearEditPanel: function() {
			$('#layout').append($('#aa_layout > fieldset').attr('data-collapse-group', '#layout'));
		},

		setDefaultAdvancedAnalyticsSettings: function(settings) {
			defaultAdvancedAnalyticsSettings = settings;
		},

		getDefaultAdvancedAnalyticsSettings: function() {
			return defaultAdvancedAnalyticsSettings;
		},

		validateSelections: function(settings) {
			let errMsg = '';

			if (typeof settings.selectedSetId !== 'number' || settings.selectedSetId === 0) {
				errMsg += 'Please select a test set.';
			}

			if (errMsg.length > 0) {
				Storyboard.LayoutControls.showError(errMsg);
			}

			return errMsg.length === 0;
		},

		loadFilters: function() {
			if (AdvancedAnalyticsSetup.filtersLoaded) return Promise.resolve();

			return Helpers.perfJSonCall({
				method: 'GetFilters',
				message: locale.get('Loading filters'),
				successCallback: function (filters) {
					AdvancedAnalyticsSetup.filtersLoaded = true;
					AdvancedAnalyticsSetup.bindFilters(filters);

					if (!AdvancedAnalyticsSetup.getDefaultAdvancedAnalyticsSettings())
						AdvancedAnalyticsSetup.setDefaultAdvancedAnalyticsSettings(AdvancedAnalyticsSetup.getAdvancedAnalyticsSettings());
				},
				fixCasing: true,
			});
		},

		getFilterTestSets: function() {
			const data = {
				filterText: $('#aa_txtTestSets').val() ?? '',
				extraSets: [],
				maxNoOfLevels: 0
			}

			return Helpers.perfJSonCall({
				method: 'FilterAdvancedAnalyticsTestSets',
				data: data,
				message: locale.get('Loading TestSets'),
				successCallback: function (testSets) {
					AdvancedAnalyticsSetup.bindTestSets(testSets);
				},
				fixCasing: true,
			});
		},

		loadSettings(layoutElementItem) {
			
			return Helpers.perfJSonCall({
				method: 'GetAdvancedAnalyticsDataForLayoutElementItem',
				service: 'chartsetup',
				data: {
					elementItem: layoutElementItem,
					area: 'chartsetup',
					part: ''
				},
				message: locale.get('Loading settings'),
				successCallback: function (settings) {
					AdvancedAnalyticsSetup.settingsLoaded = true;

					if (settings?.item1 !== null) {
						AdvancedAnalyticsSetup.bindAdvancedAnalyticsSettings(settings.item1);
					} else {
						AdvancedAnalyticsSetup.bindAdvancedAnalyticsSettings(AdvancedAnalyticsSetup.getDefaultAdvancedAnalyticsSettings());
					}
				},
				fixCasing: true
			});
		},

		loadStyles: function (layoutElementItem) {
			const layoutElement = Storyboard.LayoutDesigner.getLayoutElementByElementItem(layoutElementItem);

			return Helpers.perfJSonCall({
				method: 'GetChartStyles',
				data: {
					layoutElement: layoutElement,
					connString: '',
				},
				successCallback: function (styles) {
					ChartSetupUI.bindChartStylesSelectElements();
					AdvancedAnalyticsSetup.setStyleCacheWithGuid(styles, layoutElement.guid);
					AdvancedAnalyticsSetup.setStyles(styles, layoutElement.layoutElementId);
				},
				synchronous: false,
				fixCasing: false,
			});
		},

		bindAdvancedAnalyticsSettings: function (settings) {
			const userEvents = settings.userEvents ?? {};

			HTMLHelpers.setSelectedValues('#aa_testSetsBox', settings.selectedSetId);

			$('#aa_ddlAnalysisType').val(settings.calculationType);
			$('#aa_ddlOutputType').val(settings.outputType);

			$('#aaSeriesSettings .hdLegendPos').hide();
			$('#aaTimeSelections .hdMovAvg').hide();
			$('#aa_layout .chartStyleLegendSettings').hide();

			AdvancedAnalyticsSetup.setSelectedTimeSettings(settings.timeSelections, settings.optionalFilterSettings);
			AdvancedAnalyticsSetup.setSelectedSeriesSettings(settings.seriesSettings);
			AdvancedAnalyticsSetup.setChartOptions(settings);
			AdvancedAnalyticsSetup.setTextOptions(settings.textOptions);
			AdvancedAnalyticsSetup.setAxisOptions(settings.axisOptions);
			AdvancedAnalyticsSetup.setSelectedFilters(settings.filters);
			AdvancedAnalyticsSetup.setOptionalFilterSettings(settings.optionalFilterSettings);
			AdvancedAnalyticsSetup.setTargetAreas(settings.targetAreas);

			$('#aa_chbAllowExcelExport').attr('checked', settings.allowExcelExport);
			$('#aa_chbAllowCSVExport').attr('checked', settings.allowCsvExport);
			$('#aa_chbExportToEditablePPTAsImage').attr('checked', settings.exportToEditablePptAsImage);

			Storyboard.LayoutDesigner.UserEvents.setAdvancedAnalyticsEventsTabUI(
				userEvents,
				document.getElementById('divAdvancedAnalytics')
			);
		},

		bindFilters(filters) {
			var template = $('#aa_filterBox > .aa_filterboxTemplate');
			template.show();
			Storyboard.GuiEvents.bindFilters(filters, 'aa_filterBox', 'aa_filterboxTemplate', false);
			Storyboard.GuiEvents.bindOptionalFilters(
				filters,
				'aa_optFilterBox',
				'aa_optionFilterTemplate',
				'aa_optionalFilterSettings'
			);
			Storyboard.GuiEvents.bindOptionalFiltersCheckAll('aa_optFilterBox');
			template.hide();
		},

		bindTestSets(testSets = []) {
			const selectedSetId = Number($('#aa_testSetsBox').val());
			HTMLHelpers.bindSelect($('#aa_testSetsBox'), testSets, 'importId', 'testName');
			HTMLHelpers.setSelectedValues('#aa_testSetsBox', selectedSetId);
		},

		setSelectedTimeSettings: function (timeSelections, optionalFilterSettings) {
			HTMLHelpers.setSelectedValues('#aa_ddlTimePeriod', timeSelections.timePeriod);
			AdvancedAnalyticsSetup.showHideDateSelections();

			$('#aa_txtTimePeriod').val('');
			$('#aa_txtTimePeriod').val(timeSelections.timePeriodSpanAmount);
			HTMLHelpers.setSelectedValues('#aa_ddlTimePeriodSpan', timeSelections.timePeriodSpan);
			HTMLHelpers.setSelectedValues('#aa_ddlDateVar', timeSelections.dateVariableId);

			let sDate = typeof timeSelections.startDate === 'string' ? parseInt(timeSelections.startDate.replace(/\D/g, ''), 10) : timeSelections.startDate;
			let jsSDate = new Date(sDate);
			let eDate = typeof timeSelections.stopDate === 'string' ? parseInt(timeSelections.stopDate.replace(/\D/g, ''), 10) : timeSelections.stopDate;
			let jsEDate = new Date(eDate);

			$('#aa_txtStartDate').datepicker('setDate', jsSDate);
			$('#aa_txtStopDate').datepicker('setDate', jsEDate);

			var selectedTimePeriod = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.TimePeriod);

			var optionalFilterTimePeriodEnabled = (optionalFilterSettings && optionalFilterSettings.find(e => e.optionalSettingType === 4) !== undefined) ? optionalFilterSettings.find(e => e.optionalSettingType === 4).isApply : true;

			$('#aa_lblTimePeriodInfo').toggle((selectedTimePeriod && optionalFilterTimePeriodEnabled));
		},

		setSelectedSeriesSettings: function (seriesSettings) {
			HTMLHelpers.setSelectedValues('#aa_ddlLegendPosition', seriesSettings.legendPosition);
			HTMLHelpers.setSelectedValues('#aa_dllGenerateByDecimals', seriesSettings.renderValueType);
			$("#aa_cbShowValues").attr("checked", seriesSettings.showDataLabel);
			$("#aa_chkInvertChart").attr("checked", seriesSettings.invertChart);
			$("#aa_txtNoofDecimals").val(seriesSettings.noofDecimals);
			$("#aa_chkShowUnitOnDataLabel").attr("checked", seriesSettings.showUnitOnDataLabel);
			$("#aa_chbShowSeparatorOnDataLabel").attr("checked", seriesSettings.showSeparatorOnDataLabel);
			
			HTMLHelpers.setSelectedValues('#aa_ddlColorLogic', seriesSettings.seriesColorSource);
			var hexSeriesColor = Helpers.convertFromDecimalToHex(seriesSettings.seriesColor);
			$('#aa_seriesColorPreview').DUIColorPicker({
				layout: 'template',
				transparent: false,
				selected: {
					colorString: hexSeriesColor,
					templateColorId: seriesSettings.seriesColor_colorPlaceholderId
				}
			});

			$('#aa_seriesColorCategory').val(seriesSettings.seriesColorCategoryId);

			AdvancedAnalyticsSetup.showHideColorPickers();
		},

		setChartOptions: function (settings) {
			if (settings) {
				$("#aa_chbShowFilterInTitle").attr("checked", settings.chartOptions.showFilterInTitle);
				$("#aa_chbTransformIntoPolar").attr("checked", settings.chartOptions.transformIntoPolar);
				setBitFlags('.aaTooltipItems', settings.chartOptions.tooltipItems);
				$("#aa_chbEnableTooltip").attr("checked", settings.chartOptions.enableTooltip);
				$("#aa_chbShowMagnifyingGlass").attr("checked", settings.chartOptions.showMagnifyingGlass);
				if (settings.chartOptions.enableTooltip)
					$('.aaTooltipItems').removeAttr('disabled');
				else
					$('.aaTooltipItems').attr('disabled', 'disabled');

				$("#aa_ddlBasePosition").val(settings.chartOptions.baseSizePosition);
				$("#aa_ddlShowBase").val(settings.chartOptions.baseSizeOption);

				$("#aa_chartZooming").attr("checked", settings.chartOptions.allowChartZoom);
				$("#aa_chkAutoSeriesPointWidth").attr("checked", settings.chartOptions.autoColumnBarWidth);

				$('#aa_ddlLegendPosition').val(5); // Hide legend by default
			}

			$("#aa_chkAutoSeriesPointWidth").change();
		},

		setTextOptions: function (textOptions) {
			$("#aa_cbShowQuestionTexts").attr("checked", textOptions.showQuestionTexts);
			$("#aa_cbShowAnswerTexts").attr("checked", textOptions.showAnswerTexts);
			$("#aa_cbShowThousandSeparator").attr("checked", textOptions.showThousandSeparator);
			$("#aa_chbShowPositivePrefix").attr("checked", textOptions.showPositivePrefix);
		},

		setAxisOptions: function (axisOptions) {
			if (axisOptions) {
				$("#aa_txtXAxis").val(axisOptions.xAxisText);
				$("#aa_txtYAxis").val(axisOptions.yAxisText);
				$("#aa_txtMinScale").val(axisOptions.minScale);
				$("#aa_txtMaxScale").val(axisOptions.maxScale);
				$('#aa_txtAxisUnitName').val(axisOptions.axisUnitName);
				$('#aa_ddlAxisUnitPlacement').val(axisOptions.axisUnitPlacement);
				$('#aa_chbShowUnitOnYAxis').attr("checked", axisOptions.showUnitOnYaxis);
				$('#aa_chbShowSeparatorOnYAxis').attr("checked", axisOptions.showSeparatorOnYaxis);
				$('#aa_chkAutoGrid').attr("checked", axisOptions.autoGrid);//.trigger('change');
				$("#aa_txtGridInterval").val(axisOptions.gridInterval);
			}
		},

		clearFilterSelections: function () {
			HTMLHelpers.setSelectedValues($("#aa_filterBox div select"), 0);
		},

		setSelectedFilters: function (filterArray) {
			this.clearFilterSelections();

			if (!filterArray || filterArray.length === 0) return;

			filterArray.forEach(function(filter) {
				if (!filter.filterId) return;
				var filterbox = $("#aa_filterBox").find("div #hidFilterId[value='" + filter.filterId + "']").parent();

				if (filter.allAnswers)
					HTMLHelpers.setSelectedValues(filterbox.find('select'), "all");
				else {
					var answerIds = $.map(filter.answers, function (e) { return isNaN(e.answerId) ? e : e.answerId });
					HTMLHelpers.setSelectedValues(filterbox.find('select'), answerIds);
				}
			});
		},

		setOptionalFilterSettings: function (optionalFilterSettings) {
			$('.aa_chkOptFilter').attr('checked', true);

			if (optionalFilterSettings && optionalFilterSettings.length > 0) {
				optionalFilterSettings.forEach(function(ofs) {
					if (!ofs.optionalSettingType) {
						$("#aa_optionalFilterSettings").find("input[type=checkbox]").each(function () {
							$(this).attr("checked", true);
						});
						return;
					}
					if (ofs.optionalSettingType == 1) {
						$("#aa_chkOptVariableSubset").attr("checked", ofs.isApply);
					}
					else if (ofs.optionalSettingType == 2) {
						$("#aa_chkOptHFilter").attr("checked", ofs.isApply);
					}
					else if (ofs.optionalSettingType == 3) {
						AdvancedAnalyticsSetup.setOptionalFilterQuestions(ofs.questionId, ofs.isApply);
					}
					else if (ofs.optionalSettingType == 4) {
						$("#aa_chkOptTimePeriod").attr("checked", ofs.isApply);
						$("#aa_chkOptDateVariable").attr("checked", ofs.isApplyDateVariable);
					}
					else if (ofs.optionalSettingType == 5) {
						$("#aa_chkOptInterval").attr("checked", ofs.isApply);
					}
					else if (ofs.optionalSettingType == 6) {
						$("#aa_chkOptMovingAverage").attr("checked", ofs.isApply);
					}
				});
			}

			var allChecked = $('#aa_optionalFilterSettings input[type="checkbox"]')
				.filter(function () { return $(this).attr('id') !== 'aa_chkOptFilter'; })
				.filter(function () { return !$(this).is(':checked'); })
				.length === 0;

			$('#aa_optionalFilterSettings')
				.prev('.optionalFilterSettingsCheckAll').find('input[type="checkbox"]')
				.attr('checked', allChecked);
		},

		setOptionalFilterQuestions: function (questionId, isApply) {
			var boxes = $("#aa_optFilterBox div");
			for (var i = 0; i < boxes.length; i++) {
				if (questionId == parseInt($(boxes[i]).find("#hidOptQuestionId").val() || "0")) {
					$(boxes[i]).find(".aa_chkOptFilter").attr("checked", isApply);
					break;
				}
			}
		},

		setTargetAreas: function (targetAreas) {
			var taTableId = "aaTargetAreasTable", taRowTemplateClass = "aaTargetAreaTemplate";

			// remove all target area rows except for template
			$("#" + taTableId + " > tbody > .aaTargetAreaRow:not('." + taRowTemplateClass + "')").remove();
			var targetAreaTemplate = $("." + taRowTemplateClass);
			targetAreaTemplate.show();
			$(targetAreas).each(function () {
				var newRow = targetAreaTemplate.clone();
				newRow.removeClass(taRowTemplateClass);

				newRow.find('#aa_txtStartValue').val(this.startValue);
				newRow.find('#aa_txtStopValue').val(this.stopValue);

				var colorTxt = newRow.find(".ColorTextboxTemplate");
				colorTxt.addClass("ColorTextbox").removeClass("ColorTextboxTemplate");
				colorTxt
					.DUIColorPicker({
						layout: 'template',
						selected: {
							colorString: this.color,
							templateColorId: this.color_colorPlaceholderId
						}
					});

				newRow.find("#aa_btnDeleteTargetArea").bind("click", function () {
					ChartSetupUI.removeRow(this, "aaTargetAreaRow");
				});

				$("#" + taTableId + " > tbody:last").append(newRow);
			});

			targetAreaTemplate.hide();
		},

		setStyles: function (styles, layoutElementId) {
			DataGroupSelections.SetChartStyles(styles);

			// SET DEFAULT SHADOW & BORDER WIDTH
			if (layoutElementId === 0) {
				$('#chartstyle_series_borderWidth').val('0');
				$('#chartstyle_series_shadow').attr('checked', '');
			}
		},

		showHideDateSelections: function() {
			var timePeriod = $('#aa_ddlTimePeriod').val();
			if (timePeriod === consts.static_time) $('#aa_txtStartDate, #aa_txtStopDate').parent().show();
			else $('#aa_txtStartDate, #aa_txtStopDate').parent().hide();

			if (timePeriod === '27') $('#aa_txtTimePeriod, #aa_ddlTimePeriodSpan').show();
			else $('#aa_txtTimePeriod, #aa_ddlTimePeriodSpan').hide();
		},

		showHideColorPickers: function () {
			var colorSources = Storyboard.Constants.ColorSources;

			var seriesColorSource = HTMLHelpers.getSelectValue('#aa_ddlColorLogic');

			$('#aa_seriesColorPickerDiv, #aa_seriesColorTemplateDiv').hide();

			if (seriesColorSource.value == colorSources.COLOR_TEMPLATE && $.fn.DUIColorPicker.useNewColorTemplateLogic) {
				$('#aa_seriesColorTemplateDiv').show();
				$('#aa_seriesColorCategory').DUIColorSelect({layout: 'category', allCategories: false, standardPalette: true});
			}

			if (seriesColorSource.value == colorSources.SINGLE_COLOR) {
				$('#aa_seriesColorPickerDiv').show();
			}
		},

		getAdvancedAnalyticsSettings: function() {
			const layoutElementItem = AdvancedAnalyticsSetup.currentLayoutElementItem;
			const settings = {};

			settings.contentType = Storyboard.Constants.itemTypes.ADVANCEDANALYTICS;
			settings.layoutElementId = layoutElementItem?.layoutElementId ?? 0;
			settings.elementItemId = layoutElementItem?.elementItemId ?? 0;
			settings.guid = layoutElementItem?.guid ?? '';

			settings.selectedSetId = Number($('#aa_testSetsBox').val());
			settings.calculationType = Number($('#aa_ddlAnalysisType').val());
			settings.outputType = Number($('#aa_ddlOutputType').val());
			settings.timeSelections = AdvancedAnalyticsSetup.getTimeSelections();
			settings.seriesSettings = AdvancedAnalyticsSetup.getGroupingSettings();
			settings.chartOptions = AdvancedAnalyticsSetup.getChartOptions();
			settings.textOptions = AdvancedAnalyticsSetup.getTextOptions();
			settings.axisOptions = AdvancedAnalyticsSetup.getAxisOptions();
			settings.filters = AdvancedAnalyticsSetup.getFilters();
			settings.optionalFilterSettings = AdvancedAnalyticsSetup.getOptionalFilterSetting();
			settings.targetAreas = AdvancedAnalyticsSetup.getTargetAreas();
			settings.userEvents = Storyboard.LayoutDesigner.UserEvents.getEventsOptions($('#divAdvancedAnalytics'));
			settings.allowExcelExport = $("#aa_chbAllowExcelExport").is(":checked");
			settings.allowCsvExport = $("#aa_chbAllowCSVExport").is(":checked");
			settings.exportToEditablePptAsImage = $('#aa_chbExportToEditablePPTAsImage').is(':checked');

			return settings;
		},

		getTimeSelections: function() {
			var timeSelections = {};

			timeSelections.timeInterval = 7;
			timeSelections.timePeriod = $("#aa_ddlTimePeriod").val() || 0;
			timeSelections.timePeriodSpan = $("#aa_ddlTimePeriodSpan").val() || 1;
			timeSelections.timePeriodSpanAmount = $("#aa_txtTimePeriod").val() || 0;
			timeSelections.movingAverage = $("#aa_ddlMovingAverage").val() || 1;
			timeSelections.startDate = $('#aa_txtStartDate').datepicker('getDate') || new Date(1, 1, 1);
			timeSelections.stopDate = $('#aa_txtStopDate').datepicker('getDate') || new Date(1, 1, 1);
			timeSelections.strStartDate = Helpers.formatDate(timeSelections.startDate);
			timeSelections.strStopDate = Helpers.formatDate(timeSelections.stopDate);
			timeSelections.dateVariableId = $("#aa_ddlDateVar").val();

			return timeSelections;
		},

		getGroupingSettings: function() {
			return {
				invertChart: $('#aa_chkInvertChart').is(':checked'),
				seriesColorSource: $('#aa_ddlColorLogic').val(),
				seriesColor: Helpers.convertFromHexToDecimal($('#aa_seriesColorPreview').attr('title')),
				seriesColor_colorPlaceholderId: $('#aa_seriesColorPreview').DUIColorPicker('get.selectedColorId'),
				seriesColorCategoryId: $('#aa_seriesColorCategory').val(),
				showDataLabel: $('#aa_cbShowValues').is(':checked'),
				noofDecimals: $('#aa_txtNoofDecimals').val() || 0,
				legendPosition: $('#aa_ddlLegendPosition').val() || 1,
				showUnitOnDataLabel: $('#aa_chkShowUnitOnDataLabel').is(':checked'),
				showSeparatorOnDataLabel: $('#aa_chbShowSeparatorOnDataLabel').is(':checked'),
				renderValueType: $('#aa_dllGenerateByDecimals').val() || 1,
				valueBasedColoring: AdvancedAnalyticsSetup.getValueBasedColoring(),
			};
		},

		getChartOptions: function() {
			return {
				showFilterInTitle: $('#aa_chbShowFilterInTitle').is(':checked'),
				tooltipItems: getBitFlags('.aaTooltipItems'),
				baseSizeOption: parseInt($('#aa_ddlShowBase').val() || 0, 10),
				baseSizePosition: parseInt($('#aa_ddlBasePosition').val() || 5, 10),
				transformIntoPolar: $('#aa_chbTransformIntoPolar').is(':checked'),
				allowChartZoom: $('#aa_chartZooming').is(':checked'),
				enableTooltip: $('#aa_chbEnableTooltip').is(':checked'),
				showMagnifyingGlass: $('#aa_chbShowMagnifyingGlass').is(':checked'),
				autoColumnBarWidth: $('#chkAutoSeriesPointWidth').is(':checked'),
			};
		},

		getTextOptions: function() {
			return {
				showThousandSeparator: $('#aa_cbShowThousandSeparator').attr('checked'),
				showPositivePrefix: $('#aa_chbShowPositivePrefix').attr('checked'),
			};
		},

		getAxisOptions: function () {
			return {
				xAxisText: $("#aa_txtXAxis").val() || "",
				yAxisText: $("#aa_txtYAxis").val() || "",
				minScale: $("#aa_txtMinScale").val().replace(',', '.'),
				maxScale: $("#aa_txtMaxScale").val().replace(',', '.'),
				axisUnitName: $('#aa_txtAxisUnitName').val() || "",
				axisUnitPlacement: $('#aa_ddlAxisUnitPlacement').val(),
				showUnitOnYAxis: $('#aa_chbShowUnitOnYAxis').is(':checked'),
				showSeparatorOnYAxis: $('#aa_chbShowSeparatorOnYAxis').is(':checked'),
				autoGrid: $("#aa_chkAutoGrid").is(':checked'),
				gridInterval: $("#aa_txtGridInterval").val().replace(',', '.') || "0"
			};
		},

		getValueBasedColoring: function() {
			var valueBasedColoring = [];
			$('#aa_tblValueBasedColors')
				.find('tr[id^="valueBasedColor_"]')
				.each(function() {
					var index = $(this).attr('id').split('_')[1];
					var startVal = $(this)
						.find('#aa_valueBasedStartValue_' + index)
						.val();
					var endVal = $(this)
						.find('#aa_valueBasedStopValue_' + index)
						.val();
					var startConditionValue = $(this)
						.find('#aa_valueBasedStartCondition_' + index)
						.val();
					var endConditionValue = $(this)
						.find('#aa_valueBasedStopCondition_' + index)
						.val();
					var $valBsdColPreview = $(this).find('#aa_ValueBasedColorsPreview_' + index);
					startVal = startVal == '' ? 0 : parseFloat(startVal);
					endVal = endVal == '' ? 0 : parseFloat(endVal);
					if (isNaN(startVal)) startVal = 0;
					if (isNaN(endVal)) endVal = 0;

					valueBasedColoring.push({
						ColorHex: $valBsdColPreview.attr('title'),
						Color: Helpers.convertFromHexToDecimal($valBsdColPreview.attr('title')),
						StartValue: startVal,
						EndValue: endVal,
						StartConditionValue: startConditionValue,
						EndConditionValue: endConditionValue,
						colorPlaceholderId: $valBsdColPreview.DUIColorPicker('get.selectedColorId'),
					});
				});

			return valueBasedColoring;
		},

		getTargetAreas: function () {
			var taTableId = "aaTargetAreasTable", taRowTemplateClass = "aaTargetAreaTemplate";
			var targetAreas = [];
			$("#" + taTableId + " > tbody > .aaTargetAreaRow:not('." + taRowTemplateClass + "')").each(function () {
				var startValue = $(this).find("#aa_txtStartValue").val();
				var stopValue = $(this).find("#aa_txtStopValue").val();
				var color = $(this).find("#aa_txtTargetAreaColor").DUIColorPicker('get.selectedColor');
				var color_colorPlaceholderId = $(this).find("#aa_txtTargetAreaColor").DUIColorPicker('get.selectedColorId');
				if (startValue && stopValue && color) {
					var ta = {
						startValue: startValue,
						stopValue: stopValue,
						color: color,
						color_colorPlaceholderId: color_colorPlaceholderId
					};
					targetAreas.push(ta);
				}
			});

			return targetAreas;
		},

		getFilters: function() {
			var filters = [];

			$('#aa_filterBox > div:not(.aa_filterboxTemplate)').each(function() {
				var filterId = $(this).find('#hidFilterId').val();
				var questionId = $(this).find('#hidQuestionId').val();
				var allAnswers = $(this).find("select option[value='all']:selected").length > 0;

				var selectedAnswers = $(this)
					.find(allAnswers ? 'select option' : 'select option:selected')
					.filter(function() {
						return $(this).val() != '0' && $(this).val() != 'all';
					})
					.map(function() {
						return { answerId: $(this).val(), answerText: $(this).text() };
					})
					.toArray();

				if ($(selectedAnswers).length > 0) {
					var Filter = {
						filterId: filterId,
						answers: selectedAnswers,
						questionId: questionId,
						allAnswers: allAnswers,
					};

					filters.push(Filter);
				}
			});

			return filters;
		},

		getOptionalFilterSetting: function (settingId) {
			var optFilterSettings = [];
			var rowVS = new Object();
			rowVS.settingId = parseInt(settingId || '0');
			rowVS.optionalSettingType = 1;
			rowVS.isApply = $('#aa_chkOptVariableSubset').is(':checked');
			optFilterSettings.push(rowVS);

			var rowHFilter = new Object();
			rowHFilter.settingId = parseInt(settingId || '0');
			rowHFilter.optionalSettingType = 2;
			rowHFilter.isApply = $('#aa_chkOptHFilter').is(':checked');
			optFilterSettings.push(rowHFilter);

			$('#aa_optFilterBox div').each(function() {
				var rowFilter = new Object();
				rowFilter.SettingId = parseInt(settingId || '0');
				rowFilter.filterId = parseInt($(this).find('#hidOptFilterId').val() || '0');
				rowFilter.questionId = parseInt($(this).find('#hidOptQuestionId').val() || '0');
				rowFilter.optionalSettingType = 3;
				rowFilter.isApply = $(this).find('.aa_chkOptFilter').is(':checked');
				if (rowFilter.filterId > 0) optFilterSettings.push(rowFilter);
			});

			var rowTimePeriod = new Object();
			rowTimePeriod.settingId = parseInt(settingId || '0');
			rowTimePeriod.optionalSettingType = 4;
			rowTimePeriod.isApply = $('#aa_chkOptTimePeriod').is(':checked');
			optFilterSettings.push(rowTimePeriod);

			return optFilterSettings;
		},

		getStyles: function() {
			return ChartSetupUIObj.GetChartStyles($('#aa_layout'));
		},

		addNewTargetArea: function() {
			var taTableId = "aaTargetAreasTable", taRowTemplateClass = "aaTargetAreaTemplate";
			var newRow = ChartSetupUI.addRowFromTemplate(taTableId, taRowTemplateClass, { layout: 'template' });

			newRow.find("#aa_btnDeleteTargetArea").bind("click", function () {
				ChartSetupUI.removeRow(this, "aaTargetAreaRow");
			});
		},

		previewAdvancedAnalytics() {
			const advancedAnalyticsData = AdvancedAnalyticsSetup.getAdvancedAnalyticsSettings();
			const styles = AdvancedAnalyticsSetup.getStyles();
			const generalSettings = GeneralSettings.getSelectedSettings();
			const elementItem = AdvancedAnalyticsSetup.currentLayoutElementItem;
			let chartOptions;

			if (!AdvancedAnalyticsSetup.validateSelections(advancedAnalyticsData)) return;

			const params = {
				advancedAnalyticsData,
				generalSettings,
				elementItem,
				styles: [],
				columnToSortBy: '',
				sortDirection: 0
			};

			$('#divAdvancedAnalytics').empty();

			Helpers.perfJSonCall({
				method: 'GetAdvancedAnalyticsChart',
				service: 'chartsetup',
				data: params,
				successCallback: function(chartData) {
					renderPreview(chartData);
				},
				message: "Rendering advanced analytics preview"
			});

			function renderPreview(chartData) {
				ChartSetupDataCom.GetChartData(chartData);
				chartOptions = chartData.chartOptions;

				const $previewEl = $('#divAdvancedAnalytics').width(elementItem.width).height(elementItem.height);

				if (chartData.customMessage && chartData.customMessage.length > 0) {
					$previewEl.children().remove();
					$previewEl.html(
						$('<div/>', {
							class: 'layoutElementCustomMessage',
							html: $('<span/>', {
								class: 'customMessage',
								text: locale.get(chartData.customMessage)
							})
						})
					);
					$previewEl.show();
				} else if (chartData.chartOptions == 'nodata') {
					$previewEl.children().remove();
					$previewEl.addClass("layoutElementNoData");
					$previewEl.show();
				} else {
					$previewEl.removeClass("layoutElementNoData layoutElementCustomMessage");

					/* stuff needs to be visible in order for correct measuring in chart!! */
					$previewEl.show();
					$('.invertBackground', '#advancedAnalyticsPreview').show();
					redrawChart();
				}

				$('#divAdvancedAnalyticsTable').empty();

				if (chartData.tableCss)
					$('<style>').text(chartData.tableCss).appendTo($('#divAdvancedAnalyticsTable'));
				$("#divAdvancedAnalyticsTable").append(chartData.tableHtml);
			}

			function redrawChart() {
				if (!chartOptions)
					return;
	
				if (advancedAnalyticsData.chartOptions.allowChartZoom)
					chartOptions.chart.zoomType = 'xy';
				else
					chartOptions.chart.zoomType = '';
	
				chartOptions.chart.guid = 'preview';

				Storyboard.HighchartsWrapper.produceChart('divAdvancedAnalytics', chartOptions, null, false, null, styles, advancedAnalyticsData.userEvents);
			}
		},

		eventUpdateAdvancedAnalytics: function (layoutElement, advancedAnalyticsData) {
			var itemTypes = Storyboard.Constants.itemTypes;
			var layoutElementItem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.ADVANCEDANALYTICS, layoutElement);
			var advancedAnalyticsDiv = document.querySelector(".layoutElementItem[guid='" + layoutElementItem.guid + "']");
			Helpers.fixDotnetCasing(advancedAnalyticsData);
	
			AdvancedAnalyticsSetup.renderAdvancedAnalytics(advancedAnalyticsDiv, advancedAnalyticsData, layoutElementItem.guid);
		},

		redrawAdvancedAnalytics: function (layoutElementItem) {
			if (layoutElementItem != null) {
				const guid = layoutElementItem.guid;
				if (guid !== '') {
					$('#' + guid).html('');
					var data = AdvancedAnalyticsSetup.getDataFromCache(guid);
					if (data) {
						var div = document.querySelector(".layoutElementItem[guid='" + guid + "']");
						AdvancedAnalyticsSetup.renderAdvancedAnalytics(div, data, guid);
					}
				}
			}
		},

		renderAdvancedAnalytics: function(chartDiv, chartData, guid) {
			const layoutElementItem = Storyboard.LayoutDesigner.getElementItemByGuid(guid);
			const layoutElement = Storyboard.LayoutDesigner.getLayoutElementByElementItem(layoutElementItem);
			let chartOptions, customMessage, styles, userEvents;
			
			if (chartData) {
				AdvancedAnalyticsSetup.setDataToCache(structuredClone(chartData), guid);
				chartData = ChartSetupDataCom.GetChartData(chartData);
				chartOptions = chartData.chartOptions;
				customMessage = chartData.customMessage;
				styles = chartData.chartStyles;
				userEvents = chartData.userEvents;
			}

			if (layoutElementItem) {
				if (customMessage && customMessage.length > 0) {
					$(chartDiv).removeClass("layoutElementAdvancedAnalytics").addClass("layoutElementCustomMessage")
							.html($('<span/>', { class: 'customMessage', text: locale.get(customMessage) }));
				} else if (chartOptions && (chartOptions == 'nodata' || chartOptions == 'notpreloaded')) {
					if (Storyboard.LayoutDesigner.useNewNoDataLayout) {
						$(chartDiv).removeClass("layoutElementAdvancedAnalytics").addClass("layoutElementNoDataText")
							.html($('<span/>', { className: 'noData', html: locale.get('no data') }));
					} else {
						$(chartDiv).removeClass("layoutElementAdvancedAnalytics").addClass("layoutElementNoData").empty();
					}

					$(chartDiv).css({ 'background-image': '' });
					Storyboard.HighchartsWrapper.destroyCharts(guid);
				} else if (chartOptions) {
					$(chartDiv).removeClass("layoutElementNoData layoutElementNoDataText layoutElementCustomMessage").addClass("layoutElementAdvancedAnalytics");
					$(chartDiv).css({ 'background-image': 'none', 'background-color': 'transparent' });

					chartOptions.chart.guid = guid;
					Storyboard.HighchartsWrapper.produceChart(chartDiv, chartOptions, guid, true, null, styles, userEvents);
					Storyboard.GuiEvents.renderExcelExportOption(layoutElement, chartDiv, chartData);
				} else {
					$(chartDiv).empty();
				}
			} else {
				$(chartDiv).css({ 'background-image': 'none', 'background-color': 'transparent' });
			}

			if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
				Storyboard.SlidesPanel.renderThumbnailFromSVGs();
			}
		},

		saveSettings:  function(layoutElementItem) {
			const advancedAnalyticsData = AdvancedAnalyticsSetup.getAdvancedAnalyticsSettings();
			const elementItem = layoutElementItem;

			if (!AdvancedAnalyticsSetup.validateSelections(advancedAnalyticsData)) return;

			var data = {
				advancedAnalyticsData,
				elementItem
			};

			return Helpers.perfJSonCall({
				method: 'SaveAdvancedAnalyticsData',
				service: 'chartsetup',
				data: data,
				message: locale.get('Saving settings'),
			});
		},

		saveStyles: function(layoutElementItem) {
			const layoutElement = Storyboard.LayoutDesigner.getLayoutElementByElementItem(layoutElementItem);
			const styles = AdvancedAnalyticsSetup.getStyles();

			const data = {
				StyleGroup: {
					ChartStyles: styles,
					layoutElement: layoutElement
				}
			};

			return Helpers.perfJSonCall({
				method: 'SaveChartStyles',
				data: data,
				message: locale.get('Saving styles'),
			});
		},

		saveSetup: function(layoutElementItem) {
			var layoutElement = Storyboard.LayoutDesigner.getLayoutElementByElementItem(layoutElementItem);
			var leguid = layoutElement.guid;

			Storyboard.Dependency.start('ADVANCEDANALYTICS', 'SaveAdvancedAnalytics');

			return Promise.all([
				AdvancedAnalyticsSetup.saveStyles(layoutElementItem),
				AdvancedAnalyticsSetup.saveSettings(layoutElementItem),
			]).then(function() {

				var items = [layoutElement];
				Storyboard.LayoutDesigner.loadStorytellerContentForElements(items, true, false, 0, 0, null, leguid, false);

				Storyboard.Dependency.complete('ADVANCEDANALYTICS', 'SaveAdvancedAnalytics');
			});
		},
	};
})();

$(document).ready(function() {
	if (!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview()) return;

	$('#btnUpdateAdvancedAnalytics').click(function() {
		AdvancedAnalyticsSetup.previewAdvancedAnalytics();
	});

	$("#aa_ddlTimePeriod").change(function () {
		AdvancedAnalyticsSetup.showHideDateSelections();
	});

	$("#aa_btnAddTargetArea").bind("click", function () {
		AdvancedAnalyticsSetup.addNewTargetArea();
	});

	$('#aa_ddlColorLogic').change(function () {
		AdvancedAnalyticsSetup.showHideColorPickers();
	});

	$('#aa_seriesColorPreview').DUIColorPicker({
		layout: 'template',
		transparent: false,
	});

	$("#chbInvertAdvancedAnalyticsPreview").bind('change', function () {
		$('#setupAdvancedAnalyticsTab #preview').toggleClass('invert', this.checked);
	});

	$("#chbShowAdvancedAnalyticsTable").bind('change', function () {
		$('#divAdvancedAnalyticsTable').slideToggle('fast');
	});

	var custFormat = 'dd/mm/yy';
	if (typeof custDateFormatDP === 'string' && custDateFormatDP !== "")
		custFormat = custDateFormatDP;

	$('#setupAdvancedAnalyticsTab .dateInput').datepicker('destroy');
	$('#setupAdvancedAnalyticsTab .dateInput').datepicker({
		dateFormat: custFormat,
		showWeek: true,
		firstDay: 1,
		changeMonth: true,
		changeYear: true
	});

	var strToDate = function (str) {
		var arr = str.split(',');
		return new Date(arr[0], arr[1], arr[2]);
	};

	if ($('#aa_txtStartDate').length > 0) {
		$('#aa_txtStartDate').datepicker('setDate', strToDate($('#aa_txtStartDate').attr('defaultdate')));
		$('#aa_txtStartDate').datepicker('option', 'defaultDate', strToDate($('#aa_txtStartDate').attr('defaultdate')));
	}
	
	if ($('#aa_txtStopDate').length > 0) {
		$('#aa_txtStopDate').datepicker('setDate', strToDate($('#aa_txtStopDate').attr('defaultdate')));
		$('#aa_txtStopDate').datepicker('option', 'defaultDate', strToDate($('#aa_txtStopDate').attr('defaultdate')));
	}

	Helpers.setupNumericTextbox('#aa_txtMinScale');
	Helpers.setupNumericTextbox('#aa_txtMaxScale');
	Helpers.setupNumericTextbox('#aa_txtNoofDecimals', { minValue: 0, maxValue: 15 });
	Helpers.setupNumericTextbox('#aa_txtTimePeriod', { minValue: 1, allowDecimals: false });

	$('#aa_txtTestSets').bind('keyup', function () { AdvancedAnalyticsSetup.getFilterTestSets(); });
});
